export default __webpack_public_path__ + "f3481f57ab8e2f74e227a35675486f21.jpg";